import React,{ useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePosition } from '../utils/MapUtils/MapContext/PositionContext';
import { isMobile } from 'react-device-detect';

import { Box } from '@mui/joy';

import { WaiverModalIMPORTANT, SpearheadWarningModal } from '../utils/Modals/infoUpdateModals';
import {BlankMapBody, SpearheadMapBody,WB512600, WB256600, WB1024600, WhistlerBlackcombMapBody} from './mapBody';
import {Navbar} from './Navbar'
import Footer from '../utils/Footer';

const UnAuthMaps =()=>{

    const [currentMap, setCurrentMap] = useState('WBLowRes')
    const [signWaiver, setSignWaiver]= useState(true)
    const [spearheadWarning, setSpearheadWarning] = useState(false)
    
    const { setPosition } = usePosition();
    // navigation calls
    const location = useLocation();
    const navigate = useNavigate()
  
// handles spearhead disclaimer logic
    const handleSpearheadWarningClose=()=> {
        setSpearheadWarning(false)
      }
      useEffect(()=>{
        if (currentMap === 'spearhead') {
          setSpearheadWarning(true)
        }
      }, [currentMap])

// waiver signing
    const handleSignWaiverClose = () => {
    setSignWaiver(false)
    }

// handles changing of current map
    const handleSetCurrentMap = (map) => {
    setCurrentMap(map)
    setPosition({ latitude: null, longitude: null, zoom: null })
    }

    return (


        <Box className={location.pathname === '/login' ? 'login-background' : ''}>

        <Navbar handleSetCurrentMap={handleSetCurrentMap} currentMap={currentMap} setCurrentMap={setCurrentMap}/>
        <WaiverModalIMPORTANT open={signWaiver} handleClose={handleSignWaiverClose} signedIn={true}/>
        <SpearheadWarningModal open={spearheadWarning} handleClose={handleSpearheadWarningClose}/>
        {location.pathname === '/maps'
        &&
        currentMap === 'blankmap' ? <BlankMapBody handleSetCurrentMap={handleSetCurrentMap}/>:
        currentMap === 'spearhead' ? <SpearheadMapBody isSignedIn={false}/>:
        currentMap === 'WhistlerBlackcomb' ? <WhistlerBlackcombMapBody isSignedIn={true}/>:
        <WhistlerBlackcombMapBody isSignedIn={true}/>
        }
        <Footer/>
        </Box>

    )
}
export {UnAuthMaps}